import { useState, useCallback } from 'react';
import type { Deadline } from '@/components/ui/columns-tasks';

export const useTaskDialogs = () => {
  const [createDialogOpen, setCreateDialogOpen] = useState(false);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [selectedTask, setSelectedTask] = useState<Deadline | null>(null);

  const openCreateDialog = useCallback(() => {
    setCreateDialogOpen(true);
  }, []);

  const openEditDialog = useCallback((task: Deadline) => {
    setSelectedTask(task);
    setEditDialogOpen(true);
  }, []);

  const closeDialogs = useCallback(() => {
    setCreateDialogOpen(false);
    setEditDialogOpen(false);
    setSelectedTask(null);
  }, []);

  return {
    createDialogOpen,
    editDialogOpen,
    selectedTask,
    openCreateDialog,
    openEditDialog,
    closeDialogs,
    setCreateDialogOpen,
    setEditDialogOpen,
  };
};
